import { render, staticRenderFns } from "./CalendarSmall.vue?vue&type=template&id=2684443f&scoped=true&"
import script from "./CalendarSmall.vue?vue&type=script&lang=js&"
export * from "./CalendarSmall.vue?vue&type=script&lang=js&"
import style0 from "./CalendarSmall.vue?vue&type=style&index=0&id=2684443f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2684443f",
  null
  
)

export default component.exports